// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__14I4K","list":"PatternAutocomplete_list__31bJM"};